import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description GalaxyStore icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { GalaxyStore } from '@sravni/design-system-icons'
 *
 * <GalaxyStore />
 * ```
 */
var GalaxyStore = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "GalaxyStore", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m9.086 7.835-.047.189h3.411l-.047-.189c0-.93-.744-1.686-1.659-1.686-.914 0-1.658.757-1.658 1.686Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.672 19.83C2.016 18.47.762 15.8.737 11.459a55.05 55.05 0 0 1 0-.671 55.05 55.05 0 0 1 0-.672c.025-4.342 1.279-7.01 3.935-8.372 1.56-.8 2.532-.955 6.039-.956h.067c3.507 0 4.48.156 6.04.956 2.762 1.416 3.865 3.71 3.914 8.136.004.316.005.618.004.908.001.29 0 .592-.004.907-.049 4.426-1.152 6.72-3.914 8.137-1.56.8-2.533.955-6.04.956h-.067c-3.507-.001-4.48-.156-6.04-.956Zm9.016-11.995.042.189h2.416l-.651 6.176c-.13 1.256-1.172 2.209-2.414 2.209H8.409c-1.243 0-2.284-.953-2.415-2.21l-.651-6.175H7.76l.042-.189c0-1.65 1.32-2.992 2.943-2.992 1.622 0 2.943 1.342 2.943 2.992Z", fill: "currentColor" }))); });

export { GalaxyStore };
//# sourceMappingURL=GalaxyStore.js.map
